import { DataTypeEnum } from "../_common/enum/dataType.enum";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "dropdown";

export type ParentItem = { propertyName: string; value: number | string };
export type ParentId = number | string | ParentItem[];

export const dropdownService = {
    fetchFormData,
    fetchFormDataMultiple,
    fetchData,
    fetchDataWithParent
};

function fetchFormData(dataTypeEnum: DataTypeEnum, parentId?: number | string, method: string = 'GET') {
    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataTypeEnum}`;

    const url = `${API_URL}/${API_NAME}/${endpoint}/?parentId=${parentId || ""}`;

    return fetch(url, requestOptions).then(handleResponse);
}

export function isParentArray(x: ParentId): x is ParentItem[] {
    return Array.isArray(x);
}

function fetchFormDataMultiple(dataTypeEnum: DataTypeEnum, parentId?: ParentId, method: string = 'GET') {

    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataTypeEnum}`;

    let query = ``

    if (!!parentId && isParentArray(parentId)) {
        // parentId is ParentItem[] here
        query = parentId.map((m, index) => `parentIds[${index}].propertyName=${m.propertyName}&parentIds[${index}].value=${m.value}`).join("&");

    } else {
        query = `parentId=${parentId || ""}`
    }

    const url = `${API_URL}/${API_NAME}/${endpoint}/?${query}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function fetchData(dataName: string) {
    let method: string = 'GET';
    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataName}`;
    return fetch(`${API_URL}/${API_NAME}/${endpoint}/`, requestOptions).then(handleResponse);
}

function fetchDataWithParent(dataName: string, parentId?: number | string) {
    let method: string = 'GET';

    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataName}`;
    return fetch(`${API_URL}/${API_NAME}/${endpoint}/?parentId=${parentId}`, requestOptions).then(handleResponse);
}



